'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Utils


// Selectors


// Components


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _stringUtil = require('../../../../../common/utils/stringUtil');

var _liveEditingUtilSelector = require('./liveEditingUtilSelector');

var _liveEditingUtilSelector2 = _interopRequireDefault(_liveEditingUtilSelector);

var _PopupPanel = require('../../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _PopupList = require('../../../../components/popupPanel/types/PopupList');

var _PopupList2 = _interopRequireDefault(_PopupList);

var _LiveEditingEntry = require('./LiveEditingEntry');

var _LiveEditingEntry2 = _interopRequireDefault(_LiveEditingEntry);

var _PopupUserErrorEmptyContent = require('../common/PopupUserErrorEmptyContent');

var _PopupUserErrorEmptyContent2 = _interopRequireDefault(_PopupUserErrorEmptyContent);

var _PopupEmptyContent = require('../../../../components/popupPanel/PopupEmptyContent');

var _PopupEmptyContent2 = _interopRequireDefault(_PopupEmptyContent);

var _liveEditingUtilConstants = require('./liveEditingUtilConstants');

require('./LiveEditingPopup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LiveEditingPopupActiveContent = function LiveEditingPopupActiveContent(_ref) {
    var activeUserCount = _ref.activeUserCount,
        activeUsersByBoards = _ref.activeUsersByBoards;

    var title = activeUserCount + ' active ' + (0, _stringUtil.pluralise)('user', activeUserCount);
    return _react2.default.createElement(
        _PopupList2.default,
        { title: title, list: activeUsersByBoards },
        function (activeUsersByBoard, index) {
            return _react2.default.createElement(_LiveEditingEntry2.default, activeUsersByBoard);
        }
    );
};

LiveEditingPopupActiveContent.propTypes = {
    activeUserCount: _propTypes2.default.number.isRequired,
    activeUsersByBoards: _propTypes2.default.array.isRequired
};

var LiveEditingPopup = function LiveEditingPopup(props) {
    var active = props.active,
        errorActiveUserIds = props.errorActiveUserIds;


    var content = null;
    if (errorActiveUserIds.length) {
        content = _react2.default.createElement(_PopupUserErrorEmptyContent2.default, _extends({ userIds: errorActiveUserIds }, props));
    } else if (active) {
        content = _react2.default.createElement(LiveEditingPopupActiveContent, props);
    } else {
        content = _react2.default.createElement(_PopupEmptyContent2.default, { message: 'No one is currently active in boards you share' });
    }

    return _react2.default.createElement(
        _PopupPanel2.default,
        _extends({ className: (0, _classnames2.default)('LiveEditingPopup', { active: active }) }, props, {
            popupId: _liveEditingUtilConstants.LIVE_EDITING_POPUP_ID }),
        content
    );
};

LiveEditingPopup.propTypes = {
    activeUserCount: _propTypes2.default.number.isRequired,
    activeUsersByBoards: _propTypes2.default.array.isRequired,
    errorActiveUserIds: _propTypes2.default.array,
    active: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(_liveEditingUtilSelector2.default)(LiveEditingPopup);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/liveEditing/LiveEditingPopup.js
// module id = 2184
// module chunks = 0